var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:flight-roster"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2C8.145 2 5 5.145 5 9C5 11.41 6.23 13.55 8.094 14.813C4.81901 16.2177 2.42071 19.3169 2.04999 23.0013C1.9947 23.5508 2.44772 24 3 24C3.55228 24 3.99346 23.5501 4.06118 23.0019C4.54994 19.0459 7.9081 16 12 16C14.145 16 16.063 16.879 17.5 18.25L12.781 22.969L12.719 23.281L12.031 26.813L11.719 28.281L13.188 27.969L16.718 27.281L17.031 27.219L27.125 17.125C28.285 15.965 28.285 14.035 27.125 12.875C26.5652 12.3197 25.8103 12.0056 25.0218 11.9998C24.2333 11.994 23.4739 12.297 22.906 12.844L18.938 16.813C18.0565 15.9686 17.0292 15.291 15.906 14.813C16.8575 14.1707 17.637 13.3049 18.1764 12.2915C18.7158 11.2782 18.9986 10.148 19 9C19 5.145 15.855 2 12 2ZM12 4C14.773 4 17 6.227 17 9C17 11.773 14.773 14 12 14C9.227 14 7 11.773 7 9C7 6.227 9.227 4 12 4ZM25 14C25.254 14 25.52 14.082 25.719 14.281C25.8134 14.3721 25.8885 14.4813 25.9398 14.6021C25.9911 14.7229 26.0175 14.8528 26.0175 14.984C26.0175 15.1152 25.9911 15.2451 25.9398 15.3659C25.8885 15.4867 25.8134 15.5959 25.719 15.687L16.031 25.375L14.25 25.75L14.625 23.969L24.313 14.281C24.4022 14.1897 24.5092 14.1177 24.6274 14.0693C24.7455 14.021 24.8724 13.9974 25 14Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/user-management.e76d6a25ff393b30605ce362e3dae962.svg";
export { ForwardRef as ReactComponent };